import slugify from 'slugify';

import { app } from './store';
import UAParser from 'ua-parser-js';
import isWebPSupported from 'is-webp-supported';
import { media } from './media';
class Detect {
    constructor() {
        this.parser = new UAParser();
        this.useragent = this.parser.getUA();
        this.result = this.parser.getResult(this.useragent);

        app.language = document.documentElement.getAttribute('lang').split('-')[0]

        app.page = document.body.getAttribute('data-template')
        app.page == 'single-product' ? app.sku = document.body.getAttribute('data-sku') : null

        app.device = {
            desktop: this.result.device.type === undefined,
            tablet: this.result.device.type === 'tablet',
            mobile: this.result.device.type === 'mobile',
        }

        app.browser = {
            name: slugify(this.result.browser.name, { lower: true }),
            version: slugify(this.result.browser.version, { lower: true }),
        };

        app.engine = {
            name: slugify(this.result.engine.name, { lower: true }),
            version: slugify(this.result.engine.version, { lower: true }),
        };

        app.os = {
            name: slugify(this.result.os.name, { lower: true }),
            version: slugify(this.result.os.version, { lower: true }),
        };

        app.cpu = this.result.cpu.architecture;

        app.webp = isWebPSupported();
        this.classes();

        console.log(app.page, app.language, app.sku, app.device, window.innerWidth);

        window.addEventListener('resize', this.onResize);
    }

    classes() {
        // document.documentElement.classList = '';
        // OS
        document.documentElement.classList.add(app.os.name);
        document.documentElement.setAttribute('os', app.os.name);
        // Engine
        document.documentElement.classList.add(app.engine.name);
        document.documentElement.setAttribute('engine', app.engine.name);
        // Browser
        document.documentElement.classList.add(app.browser.name);
        document.documentElement.classList.add(app.browser.version);
        // document.documentElement.setAttribute('browser',app.browser.name);
        // Device
        document.documentElement.classList.add(app.device.desktop ? 'desktop' : app.device.tablet ? 'tablet' : app.device.mobile ? 'phone' : '');
        document.documentElement.setAttribute('device', app.device.desktop ? 'desktop' : app.device.tablet ? 'tablet' : app.device.mobile ? 'phone' : '');
        // CPU
        // document.documentElement.classList.add(app.cpu);
        document.documentElement.setAttribute('cpu', app.cpu);
        // WebP Images Support
        document.documentElement.setAttribute('webp', app.webp);
    }

    isPhone() {
        if (!app.PhoneChecked) {
            app.PhoneChecked = true

            app.PhoneCheck = document.documentElement.classList.contains('phone')
        }

        return app.PhoneCheck
    }

    isTablet() {
        if (!app.TabletChecked) {
            app.TabletChecked = true

            app.TabletCheck = document.documentElement.classList.contains('tablet')
        }

        return app.TabletCheck
    }

    isDesktop() {
        if (!app.DesktopChecked) {
            app.DesktopChecked = true

            app.DesktopCheck = document.documentElement.classList.contains('desktop')
        }

        return app.DesktopCheck
    }

    onResize = () => {
        if (media('<iPadPortrait')) {
            app.device = {
                desktop: false,
                tablet: false,
                mobile: true,
            }

            this.classes()

            document.documentElement.classList.remove('dekstop');
            document.documentElement.classList.remove('tablet');
        } else if (media('>=iPadPortrait', '<Laptop')) {
            app.device = {
                desktop: false,
                tablet: true,
                mobile: false,
            }

            this.classes()

            document.documentElement.classList.remove('dekstop');
            document.documentElement.classList.remove('phone');
        } else if (media('>=Laptop')) {
            app.device = {
                desktop: true,
                tablet: false,
                mobile: false,
            }

            this.classes()

            document.documentElement.classList.remove('tablet');
            document.documentElement.classList.remove('phone');
        }

        // console.log(app.page, app.device, window.innerWidth);
    }
}

const DetectionManager = new Detect();
export default DetectionManager;